var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ELSCommonUIConstants, withHTMLHeadSEO, withLoading } from 'components/common';
import TableFilter from 'components/common/table-filter/TableFilter';
import withResizeScreen from 'components/common/with-resize-screen/withResizeScreen';
import { ANALYTIC_FEATURES } from 'constants/app.constant';
import { pluralizeUnit, renderNoDataFound, renderNoResultsFound } from 'helpers/ui.helper';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { filterActions, filterSelectors } from 'redux/ducks/filter';
import { getAssignmentTypeById } from 'reports/cw/constants/report.constant';
import { remapFieldsForAssignmentEngagementTable } from 'reports/cw/services/report.service';
import { trackAAEvent } from 'services/adobe-analytics.service';
import AssignmentEngagementTableMobile from './assignment-engagement-table-mobile/AssignmentEngagementTableMobile';
import AssignmentEngagementTable from './assignment-engagement-table/AssignmentEngagementTable';
var AssignmentEngagement = /** @class */ (function (_super) {
    __extends(AssignmentEngagement, _super);
    function AssignmentEngagement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSearch = function (searchKeyword) {
            _this.props.setSearchKeyword(searchKeyword);
            trackAAEvent(ELSCommonUIConstants.analytics.eventTypes.productFeatureUsed, {
                feature: {
                    name: ANALYTIC_FEATURES.CW_COURSE_SUMMARY_ENGAGEMENT_ASSIGNMENT_DETAILS_ASSIGNMENT_TAB_ASSIGNMENT_SEARCH
                },
                searchText: searchKeyword
            });
        };
        _this.filterData = function () {
            var _a = _this.props, filteredAssignmentEngagement = _a.filteredAssignmentEngagement, searchKeyword = _a.searchKeyword;
            return filteredAssignmentEngagement
                .map(function (assignment) { return remapFieldsForAssignmentEngagementTable(assignment); })
                .filter(function (assignment) { return assignment === null || assignment === void 0 ? void 0 : assignment.name.toLowerCase().includes(searchKeyword.toLowerCase().trim()); });
        };
        return _this;
    }
    AssignmentEngagement.prototype.render = function () {
        var _a, _b;
        var _c = this.props, filteredAssignmentEngagement = _c.filteredAssignmentEngagement, assignmentTypeId = _c.assignmentTypeId, searchKeyword = _c.searchKeyword, windowMode = _c.windowMode;
        if (filteredAssignmentEngagement.length === 0) {
            return renderNoDataFound();
        }
        var data = this.filterData();
        var numberOfAssignments = data.length;
        var assignmentTypeName = (_b = (_a = getAssignmentTypeById(assignmentTypeId)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
        var assignmentEngagementTableProps = {
            tableData: data,
            assignmentTypeId: assignmentTypeId,
            searchKeyword: searchKeyword
        };
        return (<div className="u-els-margin-top-2x c-cw-assignment-engagement">
        <TableFilter filterHidden searchKeyword={searchKeyword} onSearch={this.onSearch} searchPlaceholder="Search by assignment" customClass="u-els-margin-top-2x u-els-margin-bottom-2x u-els-margin-bottom-1x@mobile">
          <h4>
            {"Showing "}
            <strong>{"".concat(numberOfAssignments, " ").concat(assignmentTypeName)}</strong>
            {" ".concat(pluralizeUnit(numberOfAssignments, 'assignment'))}
          </h4>
        </TableFilter>
        {windowMode.mobile ? <AssignmentEngagementTableMobile {...assignmentEngagementTableProps}/> : <AssignmentEngagementTable {...assignmentEngagementTableProps}/>}
        {data.length === 0 && renderNoResultsFound()}
      </div>);
    };
    return AssignmentEngagement;
}(Component));
export { AssignmentEngagement };
var mapStateToProps = function (state) { return ({
    searchKeyword: filterSelectors.getCWAssignmentEngagementTableSearch(state)
}); };
var mapDispatchToProps = function (dispatch) { return ({
    setSearchKeyword: function (searchKeyword) { return dispatch(filterActions.setCWAssignmentEngagementTableSearch(searchKeyword)); }
}); };
var enhancers = [withHTMLHeadSEO({ title: 'Assignment Engagement' }), withLoading, withRouter, connect(mapStateToProps, mapDispatchToProps), withResizeScreen];
export { AssignmentEngagement as AssignmentEngagementBase };
export default compose.apply(void 0, enhancers)(AssignmentEngagement);
